// REISOR_DRIVER_REGISTRATION_VEHICLE_PHOTO_CHECKPOINT_V1
// A cargo account is created before the required binary vehicle photo can be uploaded.
// This checkpoint makes that two-step flow idempotent across transient failures/reloads.
// The auth token is NOT duplicated here; the existing driver_token session storage is reused.

export const DRIVER_REGISTRATION_VEHICLE_PHOTO_CHECKPOINT_KEY =
  "reisor_driver_registration_vehicle_photo_v1";

function safeParse(raw) {
  try {
    const value = JSON.parse(String(raw || ""));
    return value && typeof value === "object" ? value : null;
  } catch {
    return null;
  }
}

export function readDriverRegistrationVehiclePhotoCheckpoint() {
  try {
    const stored = safeParse(
      localStorage.getItem(DRIVER_REGISTRATION_VEHICLE_PHOTO_CHECKPOINT_KEY)
    );
    if (!stored) return null;

    const driverId = String(stored.driverId || localStorage.getItem("driver_id") || "").trim();
    const token = String(localStorage.getItem("driver_token") || "").trim();
    const driverSnapshot =
      stored.driverSnapshot && typeof stored.driverSnapshot === "object"
        ? stored.driverSnapshot
        : safeParse(localStorage.getItem("driver_data")) || {};

    if (!driverId || !token) return null;

    const performerCategory = String(
      stored.performerCategory || driverSnapshot?.performerCategory || "CARGO"
    ).trim().toUpperCase();
    const status = String(stored.status || driverSnapshot?.status || "draft")
      .trim()
      .toLowerCase();

    return {
      data: {
        ok: true,
        token,
        driverId,
        driver: driverSnapshot,
      },
      outcome: {
        driverId,
        token,
        performerCategory,
        status,
        pendingPerformer: false,
        driverSnapshot: {
          ...driverSnapshot,
          _id: driverId,
          id: driverId,
          driverId,
          performerCategory,
          status,
        },
      },
      driverId,
      vehiclePhotoUploaded: Boolean(stored.vehiclePhotoUploaded),
    };
  } catch {
    return null;
  }
}

export function saveDriverRegistrationVehiclePhotoCheckpoint(checkpoint) {
  try {
    if (!checkpoint) {
      localStorage.removeItem(DRIVER_REGISTRATION_VEHICLE_PHOTO_CHECKPOINT_KEY);
      return;
    }

    const outcome = checkpoint?.outcome || {};
    const driverSnapshot =
      outcome?.driverSnapshot && typeof outcome.driverSnapshot === "object"
        ? outcome.driverSnapshot
        : {};
    const driverId = String(
      checkpoint?.driverId || outcome?.driverId || driverSnapshot?._id || ""
    ).trim();

    if (!driverId) return;

    localStorage.setItem(
      DRIVER_REGISTRATION_VEHICLE_PHOTO_CHECKPOINT_KEY,
      JSON.stringify({
        driverId,
        performerCategory: String(outcome?.performerCategory || "CARGO")
          .trim()
          .toUpperCase(),
        status: String(outcome?.status || driverSnapshot?.status || "draft")
          .trim()
          .toLowerCase(),
        driverSnapshot,
        vehiclePhotoUploaded: Boolean(checkpoint?.vehiclePhotoUploaded),
        savedAt: new Date().toISOString(),
      })
    );
  } catch {}
}

export function clearDriverRegistrationVehiclePhotoCheckpoint() {
  saveDriverRegistrationVehiclePhotoCheckpoint(null);
}
